import Spinner from "react-spinkit";


export const Loader = () => {

    return(
        <div className={"loader flexCenter"}>
            <Spinner name="cube-grid" />
        </div>
    )
}